// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1wWlq","icon":"SortAdornment_icon__3JCJX","up":"SortAdornment_up__2jTcj","down":"SortAdornment_down__3qrPf","active":"SortAdornment_active__1hsaP"};